module.exports = __webpack_public_path__ + "img/logo_light.8b6482a4.png";